import { createSlice } from "@reduxjs/toolkit";
import { Role } from "../../users/store/slice";

type InitialState = {
  data: Role[];
  isLoading: boolean;
};

const initialState: InitialState = {
  data: [],
  isLoading: false,
};

const roleSlice = createSlice({
  name: "roleSlice",
  initialState,
  reducers: {
    fetchData: (state) => {
      state.isLoading = true;
    },
    setData: (state, action) => {
      state.data = action.payload;
    },
    setIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    reset: () => initialState,
  },
});

export default roleSlice;
